export default "__VITE_ASSET__d16a2a10__"